export default "__VITE_ASSET__87799188__"